import * as Yup from 'yup';
import { useState, useContext, useEffect, useMemo, useReducer } from 'react';
import { useSearchParams } from 'react-router-dom';
// 
import { Icon } from '@iconify/react';
import { useSnackbar } from 'notistack5';
import { useFormik, Form, FormikProvider } from 'formik';
import eyeFill from '@iconify/icons-eva/eye-fill';
import closeFill from '@iconify/icons-eva/close-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
//
import moment from 'moment'
// material
import { Close } from '@material-ui/icons'
import { makeStyles, createStyles } from '@material-ui/styles';
import {
  Alert,
  Stack,
  Button,
  CircularProgress,
  Dialog,
  TextField,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  MenuItem,
  InputLabel,
  Select,
  FormControlLabel,
  Checkbox,
  ListSubheader,
  InputAdornment,
  FormControl,
  IconButton,
  Divider,
  Box,
  Typography,
  OutlinedInput,
  Autocomplete,
  Chip,
  Radio
} from '@material-ui/core';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker, TimePicker } from '@mui/x-date-pickers';
import { useDispatch, useSelector } from 'react-redux';
// hooks
import useIsMountedRef from '../../../../hooks/useIsMountedRef';
//
// import { MIconButton } from '../../../../components/@material-extend';
import ScoreCardsContext from '../../../../contexts/ScoreCardsContext'
import { AnalyticContext } from '../../../../contexts/AnalyticContext';
import { SettingsContext } from "../../../../contexts/SettingsContext"
import { getPointsOfFailureSupervisorApi } from "../../../../_apis_/authApi.js/analytic_api";
import { formulaType, DateRangeList, filterByList, setFilterByHeader } from '../../../../utils/filterUtilities';
import { handleFilterData } from '../../../../redux/slices/AnalyticsSlices/SupervisorFilterSlice';

// ------------------------------------------------------------------------

const useStyles = makeStyles(() => ({
  dropdownListStyle:
  {
    padding: 5
  },
  select: {
    backgroundColor: "#FFFFFF"
  },
  selectDisabled: {
    backgroundColor: "#E9ECEF"
  },
  textField: {
    backgroundColor: "#FFFFFF"
  },
  textFieldLock: {
    backgroundColor: "#E9ECEF"
  },
  selectLock: {
    backgroundColor: "#E9ECEF"
  }
}));

// ----------------------------------------------------------------------

export default function AnalyticSupervisorFilterDialog({ addUserButton, isDialogOpened }) {
  const loggedUserData = JSON.parse(window.localStorage.getItem('userData'));

  // CONTEXT STATES
  const { getScoreLogGroups, reportsScoreLogGroups, getScoreLogScorecards, reportsScoreLogScorecards,
    getScoreLogEventType, reportsScoreLogEventType, getScoreLogEventSubType,
    reportsScoreLogEventSubType, getScoreLogTeams, reportsScoreLogTeams,
    getScoreLogEvaluator, reportsScoreLogEvaluator,
    loading, setLoading, loadingState } = useContext(ScoreCardsContext);
  const { dataTagByScoreCard, setDataTagByScoreCard,
    getDataTagsByScoreCard, selAnaSupervisorFilters,
    setSelectedSupervisorToWeek,
    setSelectedSupervisorFromWeek,
    setselectedSupervisorDataTagFilter,
    setselectedSupervisorDataTagOperator,
    setSelectedSupervisorEventSubTypeFilter, setSupervisorPerScoreCardResponse,
    selectedSupervisorEventTypeFilter, setSelectedSupervisorEventTypeFilter,
    setSelectedSupervisorTeamFilter, selectedSupervisorTeamFilter,
    selectedSupervisorGroupFilter, setPointOfFailureSupervisorsData,
    setPointOfFailureSupervisorsLoading, selectedSupervisorDateAnaRange,
    setSelectedSupervisorDateAnaRange, getResultAcceptanceBySupervisor,
    setSelAnaSupervisorFilters, setSelectedSupervisorFilterBy,
    selScDurationInd, selectedSupervisorFromDate,
    selectedSupervisorToDate, setSelectedSupervisorToDate,
    setSelectedSupervisorFromDate, selectedSupervisorFilterBy,
    subModLabel, selectedSupervisorScorecardFilter,
    setSelectedSupervisorScorecardFilter, setSelectedSupervisorGroupFilter,
    setSelectedTeamFilter, selectedSupervisorFilter, getSupervisorByQuestion,
    warningMsg, setWarningMsg,
    loadingMap, setModuleLoading
  } = useContext(AnalyticContext);

  const { dataCreatedFrom } = useContext(SettingsContext);

  // REACT ROUTER STATES
  const [searchParams, setSearchParams] = useSearchParams();

  // REACT STATES
  const [open, setOpen] = useState(false);
  const [advanceFilters, setAdvanceFilters] = useState();
  const [customFilters, setCustomFilters] = useState(false);
  const [fromWeekNo, setFromWeekNo] = useState();
  const [toWeekNo, setToWeekNo] = useState();
  const [circular, setCircular] = useState(false);

  // Data tags state
  const [isAnyOfTag, setIsAnyOfTag] = useState(true)
  const [isAllOfTag, setIsAllOfTag] = useState(false)

  // REF STATES
  const isMountedRef = useIsMountedRef();

  // --
  const newDispatchFun = useDispatch()
  const initialState = {
    openGroupField: false,
    openScorecardField: false,
    openEventTypeField: false,
    openEventSubTypeField: false,
    openTeamField: false,
    openEvalField: false

  }

  const reducerFunc = (state, action) => {
    switch (action.type) {
      case 'SET_VALUE':
        return { ...state, ...action.payload };
      case 'RESET_VALUE':
        return initialState;
      default:
        return state;
    }
  }
  const [state, dispatch] = useReducer(reducerFunc, initialState)

  // helper function to update state value--
  const updateState = (key, value) => {
    dispatch({ type: 'SET_VALUE', payload: { [key]: value } });
  };

  // helper function to reset the state
  const resetState = (key, value) => {
    dispatch({ type: 'RESET_VALUE' });
  };

  // FORMIK STATES
  const scorecardSchemaShape = {
    scoreCardSingle: (subModLabel === 2.3 || subModLabel === 2.2) ? Yup.number().required('This Value is required').nullable() : '',
    group: (subModLabel === 2.1 || subModLabel === 2.3 || subModLabel === 2.2) ? Yup.number().required('This Value is required').nullable() : Yup.string().nullable(),
  };
  if (subModLabel === 2.1) {
    scorecardSchemaShape.scorecardField = Yup.array().min(1, 'Select at least one scorecard').required('This value is required');
  }
  const ReportSchema = Yup.object().shape(scorecardSchemaShape);

  const formik = useFormik({
    initialValues: {
      id: '',
      dateRange: '',
      filterByRange: '',
      fromDate: '',
      fromWeek: '',
      toDate: '',
      toWeek: '',
      filterBy: 'created_at',
      group: '',
      teams: '',
      scoreCard: [],
      scoreCardSingle: '',
      scoreCardSingle2: '',
      scoreCardName: [],
      eventType: '',
      eventTypeEventSubType: '',
      supervisor: '',
      staff: '',
      scoreCardCategory: '',
      evaluator: '',
      highlightValue: '',
      reference: '',
      section: '',
      formula: 10,
      subgrp: '',
      dataTag: [],
      allOfTag: '',
      anyOfTag: '',
      groupField: {},
      scorecardField: subModLabel === 2.1 ? [] : {},
      eventField: {},
      eventSubField: {},
      evaluatorField: {},
      teamField: {},
      subModule: subModLabel
    },
    validationSchema: ReportSchema,
    onSubmit: async (values, { setErrors, setSubmitting, resetForm }) => {

      // console.log("values", values)
      setCircular(true);
      try {

        if (subModLabel === 2.1) {
          // Always send actual IDs — filter out the "All" placeholder (scoreCard === '')
          const selectedScorecards = Array.isArray(values.scorecardField) ? values.scorecardField : [];
          const scoreCardValue = selectedScorecards.filter(v => v.scoreCard !== '').map(v => v.scoreCard);

          const filterObj = {
            fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
            toDate: moment(values.toDate).format('YYYY-MM-DD'),
            fromWeek: values.fromWeek,
            toWeek: values.toWeek,
            filterBy: values.filterBy,
            group: values.group,
            teams: values.teams,
            scoreCard: scoreCardValue?.join(','),
            scoreCardGroups: values?.group,
            eventType: values.eventType,
            eventTypeEventSubType: values.eventTypeEventSubType,
            staff: values.staff,
            dateRange: values?.dateRange,
            scoreCardCategory: values.scoreCardCategory,
            evaluator: values.evaluator,
            page: '1',
            filterName: '',
            highlightValue: values.highlightValue,
            section: values.section,
            supervisor: values.supervisor,
            numericValues: values.numericValues,
            formula: values.formula || '',
            dataTag: [values.dataTag] || '',
            dataTagsOperator: values.anyOfTag || values.allOfTag || '10',
            groupField: values?.groupField,
            teamField: values.teamField,
            scorecardField: values?.scorecardField,
            eventField: values?.eventField,
            eventSubField: values?.eventSubField,
            evaluatorField: values?.evaluatorField
          };
          if ((values?.dataTag?.length > 0) || (dataTagByScoreCard?.data?.length > 0)) {

            const newFilterObj = {
              ...filterObj,
              scoreCard: scoreCardValue,
              scoreCardIn: scoreCardValue,
              scoreCardSingle: scoreCardValue[0],
              dataTag: [values.dataTag] || '',
              dataTagsOperator: values.anyOfTag || values.allOfTag || '10'
            }
            newDispatchFun(handleFilterData(newFilterObj))

          } else {
            const newFilterObj = {
              ...filterObj,
              scoreCard: scoreCardValue,
              scoreCardIn: scoreCardValue,
              scoreCardSingle: scoreCardValue[0]
            }
            newDispatchFun(handleFilterData(newFilterObj))
          }
          // setSupervisorPerScoreCardResponse([])
          // setSearchParams(filterObj)
          setCircular(false);
          if (values.group !== '' || values.group !== null) {
            setSelectedSupervisorGroupFilter(values.group)
          }

          handleClose();
          // newDispatchFun(handleFilterData([...filterObj]))

          if (useIsMountedRef.current) {
            setSubmitting(false);
            setCircular(false);
            setOpen(false);
          }

        }
        if (subModLabel === 2.2) {
          const filterObj = {
            fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
            toDate: moment(values.toDate).format('YYYY-MM-DD'),
            dateRange: values.dateRange,
            fromWeek: values.fromWeek,
            toWeek: values.toWeek,
            filterBy: values.filterBy,
            group: values.group,
            teams: values.teams,
            scoreCard: values.scoreCardSingle,
            scoreCardGroups: values?.group,
            eventType: values.eventType,
            eventTypeEventSubType: values.eventTypeEventSubType,
            staff: values.staff,
            scoreCardCategory: values.scoreCardCategory,
            evaluator: values.evaluator,
            page: '1',
            filterName: '',
            highlightValue: values.highlightValue,
            section: values.section,
            supervisor: values.supervisor,
            numericValues: values.numericValues,
            formula: values.formula || '',
            sup_grp: values.subgrp || '',
            dataTag: [values.dataTag] || '',
            dataTagsOperator: values.anyOfTag || values.allOfTag || '',
            groupField: values?.groupField,
            teamField: values.teamField,
            scorecardField: values?.scorecardField,
            eventField: values?.eventField,
            eventSubField: values?.eventSubField,
            evaluatorField: values?.evaluatorField

          };

          try {
            const newFilterObj = {
              ...filterObj,
              scoreCard: values.scoreCard,
              scoreCardSingle: values.scoreCardSingle
            }
            newDispatchFun(handleFilterData(newFilterObj))
            setCircular(false);
            handleClose();

            if (values.scoreCardSingle !== '') {
              setSelectedSupervisorScorecardFilter(values.scoreCardSingle);

            }

          } catch (error) {
            if (error.name === "AxiosError" || error.code === "ERR_NETWORK" || error.message === "Network Error") {
              setWarningMsg('Too much data to load please reduce the date range')
            }
            setPointOfFailureSupervisorsData([]);
            setModuleLoading('POFSupervisor2.2', false);
            setCircular(false);
            handleClose();

          }


          if (useIsMountedRef.current) {
            setSubmitting(false);
            setCircular(false);
            setOpen(false);
          }

        }
        if (subModLabel === 2.3) {
          const filterObj = {
            fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
            toDate: moment(values.toDate).format('YYYY-MM-DD'),
            fromWeek: values.fromWeek,
            toWeek: values.toWeek,
            filterBy: values.filterBy,
            group: values.group,
            teams: values.teams,
            scoreCard: values.scoreCardSingle,
            scoreCardGroups: values?.group,
            eventType: values.eventType,
            eventTypeEventSubType: values.eventTypeEventSubType,
            staff: values.staff,
            scoreCardCategory: values.scoreCardCategory,
            evaluator: values.evaluator,
            page: '1',
            filterName: '',
            dateRange: values?.dateRange,
            highlightValue: values.highlightValue,
            section: values.section,
            supervisor: values.supervisor,
            numericValues: values.numericValues,
            formula: values.formula || '',
            sup_grp: values.subgrp || '',
            dataTag: [values.dataTag] || '',
            dataTagsOperator: values.anyOfTag || values.allOfTag || '10',
            groupField: values?.groupField,
            teamField: values.teamField,
            scorecardField: values?.scorecardField,
            eventField: values?.eventField,
            eventSubField: values?.eventSubField,
            evaluatorField: values?.evaluatorField

          };
          if (values?.anyOfTag || values?.allOfTag ||
            values?.dataTag?.length > 0 || dataTagByScoreCard?.data?.length > 0) {

            const newFilterObj = {
              ...filterObj,
              scoreCard: values.scoreCard,
              scoreCardSingle: values.scoreCardSingle,
              dataTag: [values.dataTag] || '',
              dataTagsOperator: values.anyOfTag || values.allOfTag || '10'
            }
            newDispatchFun(handleFilterData(newFilterObj))

          } else {
            const newFilterObj = {
              ...filterObj,
              scoreCard: values.scoreCard,
              scoreCardSingle: values.scoreCardSingle,
            }
            newDispatchFun(handleFilterData(newFilterObj))

          }
          // if (advanceFilters && formik.values.fromDate &&
          //   formik.values.toDate && formik.values.filterBy) {
          //   getScoreLogEventType(filterObj);
          //   getScoreLogEventSubType(filterObj);
          //   getScoreLogSupervisor(filterObj);
          // }
          if (values.scoreCardSingle !== '') {
            setSelectedSupervisorScorecardFilter(values.scoreCardSingle);
          }
          setCircular(false)
          handleClose();

          if (useIsMountedRef.current) {
            setSubmitting(false);
            setCircular(false);
            setOpen(false);
          }

        } else if (subModLabel === 2.4) {
          const filterObj = {
            fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
            toDate: moment(values.toDate).format('YYYY-MM-DD'),
            fromWeek: values.fromWeek,
            toWeek: values.toWeek,
            filterBy: values.filterBy,
            group: values.group,
            teams: values.teams,
            scoreCard: values.scoreCardSingle,
            scoreCardGroups: values?.group,
            eventType: values.eventType,
            eventTypeEventSubType: values.eventTypeEventSubType,
            staff: values.staff,
            scoreCardCategory: values.scoreCardCategory,
            evaluator: values.evaluator,
            page: '1',
            filterName: '',
            highlightValue: values.highlightValue,
            section: values.section,
            supervisor: values.supervisor,
            numericValues: values.numericValues,
            dateRange: values?.dateRange,
            sup_grp: values.subgrp || '',
            formula: values.formula || '',
            dataTag: [values.dataTag] || '',
            dataTagsOperator: values.anyOfTag || values.allOfTag || '10',
            groupField: values?.groupField,
            teamField: values.teamField,
            scorecardField: values?.scorecardField,
            eventField: values?.eventField,
            eventSubField: values?.eventSubField,
            evaluatorField: values?.evaluatorField

          };
          if (values?.anyOfTag || values?.allOfTag || values?.dataTag?.length > 0 || dataTagByScoreCard?.data?.length > 0) {

            const newFilterObj = {
              ...filterObj,
              scoreCard: values.scoreCard,
              scoreCardSingle: values.scoreCardSingle,
              dataTag: [values.dataTag] || '',
              dataTagsOperator: values.anyOfTag || values.allOfTag || '10'
            }
            // console.log('submtio 2.4', values)
            newDispatchFun(handleFilterData(newFilterObj))
            await getResultAcceptanceBySupervisor({
              ...filterObj,
              scoreCard: values.scoreCardSingle,
              scoreCardSingle: values.scoreCardSingle,
              dataTag: [values.dataTag] || '',
              dataTagsOperator: values.anyOfTag || values.allOfTag || '10'
            });
          } else {
            const newFilterObj = {
              ...filterObj,
              scoreCard: values.scoreCard,
              scoreCardSingle: values.scoreCardSingle,
            }
            // console.log('submtio 2.4 -1', values)

            newDispatchFun(handleFilterData(newFilterObj))
            await getResultAcceptanceBySupervisor({
              ...filterObj,
              scoreCard: values.scoreCardSingle,
              scoreCardSingle: values.scoreCardSingle,

            });
          }

          // setSearchParams(filterObj)
          // if (formik.values.fromDate && formik.values.toDate && formik.values.filterBy) {
          //   getScoreLogEventType(filterObj);
          //   getScoreLogEventSubType(filterObj);
          //   getScoreLogSupervisor(filterObj);
          // }

          if (values.scoreCardSingle !== '') {
            setSelectedSupervisorScorecardFilter(values.scoreCardSingle);
          }

          setCircular(false);
          handleClose();

          if (useIsMountedRef.current) {
            setSubmitting(false);
            setCircular(false);
            setOpen(false);
          }

        }

      } catch (error) {
        console.error(error);
        if (isMountedRef.current) {
          setSubmitting(false);
          setErrors({ afterSubmit: error.message });
          setCircular(false);
        }
      }
    },
    enableReinitialize: true,
  });
  const { errors, touched, values, setFieldValue, getFieldValue, handleSubmit, isSubmitting, getFieldProps } = formik;

  const filterFieldsData = useSelector(state => state?.filterFields?.filterFieldsData)
  // USEEFFECT METHODS
  // console.log('filterFieldsData', filterFieldsData)
  useMemo(() => {
    // console.log(selectedSupervisorDateAnaRange, selectedSupervisorFromDate, selectedSupervisorToDate);
    if (open) {

      if (filterFieldsData?.dateRange) {
        // console.log("one", filterFieldsData?.dateRange)
        // setFieldValue("dateRange", selectedSupervisorDateAnaRange);
        // setFieldValue("fromDate", selectedSupervisorFromDate);
        // setFieldValue("toDate", selectedSupervisorToDate);

        // redux
        setFieldValue("dateRange", filterFieldsData?.dateRange);
        setFieldValue("fromDate", filterFieldsData?.fromDate);
        setFieldValue("toDate", filterFieldsData?.toDate);

      } else if (subModLabel === 2.4) {
        setFieldValue("dateRange", 'Today');
        setFieldValue("fromDate", moment().format('YYYY-MM-DD'));
        setFieldValue("toDate", moment().format('YYYY-MM-DD'));
      } else {
        setFieldValue("dateRange", 'This Month');
        setFieldValue("fromDate", moment().startOf('month').format('YYYY-MM-DD'));
        setFieldValue("toDate", moment().endOf('month').format('YYYY-MM-DD'));
      }


      if (filterFieldsData?.dateRange === 'Custom Date Range') {
        setCustomFilters(true);
        setFieldValue("fromWeek", filterFieldsData?.fromWeek);
        setFieldValue("toWeek", filterFieldsData?.toWeek);
        setFieldValue("fromDate", filterFieldsData?.fromDate);
        setFieldValue("toDate", filterFieldsData?.toDate);
      }

      if (filterFieldsData?.filterBy) {
        setFieldValue("filterBy", filterFieldsData?.filterBy);
      } else {
        setFieldValue("filterBy", 'created_at');
      }

      // if (selectedSupervisorGroupFilter) {
      //   // setFieldValue("group", selAnaSupervisorFilters?.group);
      //   setFieldValue("group", selectedSupervisorGroupFilter);
      // }
      if (filterFieldsData?.group) {
        // setFieldValue("group", selAnaSupervisorFilters?.group);
        setFieldValue("group", filterFieldsData?.group);
      }
      else {
        setFieldValue("group", '');
      }

      if (filterFieldsData?.groupField) {
        setFieldValue("groupField", filterFieldsData?.groupField);
      } else if (subModLabel === 2.4) {
        setFieldValue("groupField", { name: 'All', id: '' });
      } else {
        setFieldValue("groupField", {});
      }

      if (filterFieldsData?.teams) {
        setFieldValue("teams", filterFieldsData?.teams);
      }
      else {
        setFieldValue("teams", '');
      }

      if (filterFieldsData?.teamField) {
        setFieldValue("teamField", filterFieldsData?.teamField);
      } else {
        setFieldValue("teamField", { id: '', name: "All" });
      }

      // console.log('filterFieldsData?.scoreCard', filterFieldsData)
      // if (filterFieldsData?.scoreCardSingle && subModLabel !== 2.1) {
      //   console.log('is single & not 2.1', filterFieldsData)
      //   setFieldValue("scoreCardSingle", filterFieldsData?.scoreCardSingle)
      //   setFieldValue("scoreCard", [filterFieldsData?.scoreCardSingle])
      //   const filterScoreCardObj = {
      //     "fromDate": values.fromDate || filterFieldsData?.fromDate,
      //     "toDate": values.toDate || filterFieldsData?.toDate,
      //     "filterBy": values.filterBy || filterFieldsData?.filterBy,
      //     "scoreCard": filterFieldsData?.scoreCardSingle ?? '',
      //   }
      //   getDataTagsByScoreCard(filterScoreCardObj);
      // }
      // else if (subModLabel !== 2.1) {
      //   setFieldValue("scoreCardSingle", '');
      // }
      if (filterFieldsData?.scorecardField) {
        if (subModLabel === 2.1) {
          // Restore as array, handle legacy single-object values gracefully
          const sc = filterFieldsData.scorecardField;
          let restoredArray;
          if (Array.isArray(sc)) {
            restoredArray = sc;
          } else if (sc?.scoreCard !== undefined) {
            restoredArray = [sc];
          } else {
            restoredArray = [];
          }
          // const isAll = restoredArray.some(v => v.scoreCard === '');
          // const scoreCardIds = isAll ? '' : restoredArray.map(v => v.scoreCard);
          // console.log('restoredArray', restoredArray, '---->', scoreCardIds)
          // setFieldValue('scoreCard', scoreCardIds)
          setFieldValue("scorecardField", restoredArray);

          // remove objects where scoreCard === ''
          const filteredArray = restoredArray.filter(v => v?.scoreCard !== '');

          const scoreCardIds = filteredArray.map(v => v.scoreCard);

          console.log('restoredArray', restoredArray, '---->', scoreCardIds);

          setFieldValue('scoreCard', scoreCardIds);
          setFieldValue("scoreCardSingle", scoreCardIds[0] || '');
          const filterScoreCardObj = {
            "fromDate": values.fromDate || filterFieldsData?.fromDate,
            "toDate": values.toDate || filterFieldsData?.toDate,
            "filterBy": values.filterBy || filterFieldsData?.filterBy,
            "scoreCard": scoreCardIds?.join(','),
          };
          getDataTagsByScoreCard(filterScoreCardObj);
        } else {
          console.log('filterFieldsData?.scorecardField', filterFieldsData, Array.isArray(filterFieldsData?.scorecardField))
          setFieldValue("scorecardField", filterFieldsData?.scorecardField);
          let scorecardArray = [];

          if (Array.isArray(filterFieldsData?.scorecardField)) {
            scorecardArray = filterFieldsData?.scorecardField;
          } else if (filterFieldsData?.scorecardField) {
            scorecardArray = [filterFieldsData?.scorecardField];
          }

          // const validScorecards = scorecardArray.filter(sc => sc?.scoreCard !== '');
          const validScorecardIds = scorecardArray
            .filter(sc => sc?.scoreCard !== '')
            .map(sc => sc?.scoreCard);
          console.log('validScorecards', validScorecardIds);

          setFieldValue('scoreCard', validScorecardIds);
          setFieldValue('scoreCardSingle', validScorecardIds[0] || '');
          // 2. Build the object
          const filterScoreCardObj = {
            "fromDate": values.fromDate || filterFieldsData?.fromDate,
            "toDate": values.toDate || filterFieldsData?.toDate,
            "filterBy": values.filterBy || filterFieldsData?.filterBy,
            // Use the first element of the filtered array, or default to empty string
            "scoreCard": validScorecardIds[0] ?? '',
          };

          getDataTagsByScoreCard(filterScoreCardObj);
        }
      }
      // else if (subModLabel === 2.4) {
      //   setFieldValue("scorecardField", { scoreCard: '', scoreCardName: 'All' });
      // } else if (subModLabel === 2.1) {
      //   setFieldValue("scorecardField", []);
      // } else {
      //   setFieldValue("scorecardField", {});
      // }

      if (filterFieldsData?.eventType) {
        setFieldValue("eventType", filterFieldsData?.eventType);
      } else {
        setFieldValue("eventType", '')
      }
      if (filterFieldsData?.eventField) {
        setFieldValue("eventField", filterFieldsData?.eventField);
      } else {
        setFieldValue("eventField", {
          eventType: '',
          eventTypeEventType: "All",
          scoreCard: ''
        })
      }
      // console.log('selectedSupervisorEventTypeFilter', selectedSupervisorEventTypeFilter, selectedSupervisorEventSubTypeFilter)
      if (filterFieldsData?.eventTypeEventSubType) {
        setFieldValue("eventTypeEventSubType", filterFieldsData?.eventTypeEventSubType);
      } else {
        setFieldValue("eventTypeEventSubType", '')
      }

      if (filterFieldsData?.eventSubField) {
        setFieldValue("eventSubField", filterFieldsData?.eventSubField);
      } else {
        setFieldValue("eventSubField", {
          eventSubType: '',
          subType: "All",
          scorecard: ''
        })
      }

      if (filterFieldsData?.evaluator) {
        setFieldValue("evaluator", filterFieldsData?.evaluator);
      } else {
        setFieldValue("evaluator", '')
      }

      if (filterFieldsData?.evaluatorField) {
        setFieldValue("evaluatorField", filterFieldsData?.evaluatorField);
      } else {
        setFieldValue("evaluatorField", {
          evaluator: '',
          evaluatorFirstName: 'All',
          evaluatorLastName: ''
        });
      }

      if (filterFieldsData?.highlightValue) {
        setFieldValue("highlightValue", filterFieldsData?.highlightValue)
      } else {
        setFieldValue("highlightValue", 0);
      }

      // console.log('selectedSupervisorDataTagFilter', selectedSupervisorDataTagFilter)
      if (filterFieldsData?.dataTag?.length > 0) {
        setFieldValue('dataTag', filterFieldsData?.dataTag)
      } else {
        setFieldValue('dataTag', [])
      }

      // console.log('selectedSupervisorDataTagOperator',
      //   selectedSupervisorDataTagOperator === '20',
      //   searchParams.get('dataTagsOperator'))
      if ((filterFieldsData?.dataTagsOperator || searchParams.get('dataTagsOperator')) !== '20') {
        setIsAnyOfTag(true)
        setIsAllOfTag(false)
        setFieldValue('anyOfTag', '10')
        setFieldValue('allOfTag', '');

      } else {
        setIsAnyOfTag(false)
        setIsAllOfTag(true)
        setFieldValue('allOfTag', '20');
        setFieldValue('anyOfTag', '');
      }

      // if (selectedSupervisorDataTagOperator !== '20') {
      //   setIsAnyOfTag(true)
      //   setIsAllOfTag(false)
      // } else {
      //   setIsAnyOfTag(false)
      //   setIsAllOfTag(true)
      // }

      setFieldValue("scoreCardCategory", '');

      if (searchParams.get('formula')) {
        setFieldValue('formula', searchParams.get('formula'))
      } else {
        setFieldValue('formula', '')
      }

    }
  }, [open]);
  // console.log('filterFieldsData', values, filterFieldsData)
  useEffect(() => {

    const arrFromWeek = [];
    const arrToWeek = [];
    if (formik.values.fromWeek > moment().week()) {
      for (let i = 1; i <= formik.values.fromWeek; i) {
        arrFromWeek.push(i);
        i += 1;
      }
      setFromWeekNo(arrFromWeek);
    } else {
      for (let i = 1; i <= moment().week(); i) {
        arrFromWeek.push(i);
        i += 1;
      }
      setFromWeekNo(arrFromWeek);
    }

    if (formik.values.toWeek > moment().week()) {
      for (let i = 1; i <= formik.values.toWeek; i) {
        arrToWeek.push(i);
        i += 1;
      }
      setToWeekNo(arrToWeek);
    } else {
      for (let i = 1; i <= moment().week(); i) {
        arrToWeek.push(i);
        i += 1;
      }
      setToWeekNo(arrToWeek);
    }

  }, [formik?.values]);



  // Open user dialog modal
  const handleClickOpen = () => {
    setOpen(true);
  };


  // Close user dialog modal
  const handleClose = (event, reason) => {

    if (reason !== 'backdropClick') {

      setOpen(false)
    }
  };

  // METHODS

  const handleOpenGroupFields = async () => {
    // setLoading(true);

    const groupFilterObj = {
      fromDate: moment(values.fromDate).format('YYYY-MM-DD'),
      toDate: moment(values.toDate).format('YYYY-MM-DD'),
      filterBy: values.filterBy,
      sup_grp:
        loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30
          ? loggedUserData?.groups?.map((obj) => obj.id)
          : ''
    };
    // setOpenGroupFields(true);
    updateState('openGroupField', true)
    // console.log('reportsScoreLogGroups before', reportsScoreLogGroups)
    // (async () => {
    // if (reportsScoreLogGroups?.length === 0) {
    await getScoreLogGroups(groupFilterObj);
    // }

    // })();
    // setLoading(false);

  };

  const handleCloseFields = () => {
    updateState('openGroupField', false)
    updateState('openScorecardField', false)
    updateState('openEventTypeField', false)
    updateState('openEventSubTypeField', false)
    updateState('openTeamField', false)
    updateState('openEvalField', false)

  };

  const handleGroupChange = (event, newValue) => {

    // Resetting remaining fields
    setFieldValue("teams", '');
    setFieldValue("eventType", '');
    setFieldValue("eventTypeEventSubType", '');
    setFieldValue("staff", '');
    setFieldValue("scoreCardCategory", '');
    setFieldValue("evaluator", '');
    setFieldValue("supervisor", '');
    setFieldValue("highlightValue", '');
    setFieldValue("section", '');
    setFieldValue("scoreCardSingle", '');
    setFieldValue('dataTag', [])

    setFieldValue('groupField', newValue)
    setFieldValue("group", newValue?.id ?? '');
    setFieldValue('scorecardField', subModLabel === 2.1 ? [] : {});
    setFieldValue('scoreCardSingle', '');

    setFieldValue('teamField', {
      id: '', name: 'All'
    });
    // setSelectedSupervisorGroupFilter(newValue?.id ?? '');
    const filterObj =
    {
      "fromDate": values.fromDate,
      "toDate": values.toDate,
      "filterBy": values.filterBy,
      "group": (newValue?.id || selectedSupervisorGroupFilter) ?? '',
      "teams": '',
      "scoreCard": '',
      "eventType": '',
      "eventTypeEventSubType": '',
      "supervisor": '',
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": '',
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id).join(',') : ''
    }

    // getScoreLogTeams(filterObj);
    // getScoreLogScorecards(filterObj);
    // getScoreLogEventType(filterObj);
    // getScoreLogEventSubType(filterObj);

  };
  // console.log('selectedSupervisorGroupFilter', selectedSupervisorGroupFilter, reportsScoreLogGroups)

  const handleOpenTeamFields = () => {
    updateState('openTeamField', true)
    const teamFilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": '',
      "eventType": '',
      "eventTypeEventSubType": '',
      "supervisor": '',
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": '',
      "highlightValue": '',
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id).join(',') : ''
    }
    getScoreLogTeams(teamFilterObj)
  }
  const handleTeamChange = (event, newVal) => {
    // Resetting remaining fields
    setFieldValue("scoreCardSingle", []);
    setFieldValue("eventType", '');
    setFieldValue("eventTypeEventSubType", '');
    setFieldValue("staff", '');
    setFieldValue("scoreCardCategory", '');
    setFieldValue("evaluator", '');
    setFieldValue("supervisor", '');
    setFieldValue("highlightValue", '');
    setFieldValue("section", '');
    setFieldValue('dataTag', [])
    setFieldValue('dataTagsOperator', '10')

    setFieldValue("teams", newVal?.id);
    setFieldValue('teamField', newVal)
    // setSelectedSupervisorTeamFilter(event.target.value);

    // redux state fields
    setFieldValue('scorecardField', {});
    setFieldValue('scoreCardSingle', '');
    setFieldValue("eventField", {
      eventType: '',
      eventTypeEventType: "All",
      scoreCard: ''
    })
    setFieldValue('eventSubField', {
      eventSubType: '',
      subType: 'All',
      scorecard: ''
    })

  };

  const handleDataTags = (event) => {
    // console.log('data tag', event)
    setFieldValue("dataTag", (event.target.value).flat(100));
    // setselectedSupervisorDataTagFilter((event.target.value).flat(100));
    // localStorage.setItem('dataTags', JSON.stringify((event.target.value).flat(100)))

    // console.log('dataTag', (event.target.value).flat(100));
  }

  const handleAnyOfTag = (event) => {
    setFieldValue('allOfTag', '')
    setFieldValue('anyOfTag', '10')
    setselectedSupervisorDataTagOperator('10')
    setIsAnyOfTag(true)
    setIsAllOfTag(false)
  }

  const handleAllOfTag = () => {
    setFieldValue('dataTag', [])
    setFieldValue('anyOfTag', '')
    setFieldValue('allOfTag', '20')
    setselectedSupervisorDataTagOperator('20')
    setIsAnyOfTag(false)
    setIsAllOfTag(true)
  }

  const handleOpenScorecardFields = async () => {
    updateState('openScorecardField', true)
    const scoreCardfilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": '',
      "eventType": '',
      "eventTypeEventSubType": '',
      "supervisor": '',
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": '',
      "highlightValue": '',
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id).join(',') : ''
    }
    await getScoreLogScorecards(scoreCardfilterObj);

  }
  const handleScorecardChange = (event, newValue) => {
    // Reset dependent fields (shared for both single and multi-select)
    setFieldValue("eventType", '');
    setFieldValue("eventTypeEventSubType", '');
    setFieldValue("staff", '');
    setFieldValue("scoreCardCategory", '');
    setFieldValue("evaluator", '');
    setFieldValue("supervisor", '');
    setFieldValue("highlightValue", '');
    setFieldValue("section", '');
    setFieldValue("dataTag", []);
    setSelectedSupervisorEventTypeFilter('');
    setSelectedSupervisorEventSubTypeFilter('');

    if (subModLabel === 2.1) {
      // Multi-select handling with "All" option
      const allOption = { scoreCardName: 'All', scoreCard: '' };
      const allScorecards = reportsScoreLogScorecards || [];
      const prevHadAll = Array.isArray(values.scorecardField) && values.scorecardField.some(v => v.scoreCard === '');
      const newHasAll = Array.isArray(newValue) && newValue.some(v => v.scoreCard === '');

      let finalSelection;
      if (!prevHadAll && newHasAll) {
        // "All" just selected — select All + every individual scorecard
        finalSelection = [allOption, ...allScorecards];
      } else if (prevHadAll && !newHasAll) {
        // "All" was deselected — clear everything
        finalSelection = [];
      } else if (prevHadAll && newHasAll) {
        // "All" still present but an individual item was toggled — remove "All", keep rest
        finalSelection = newValue?.filter(v => v.scoreCard !== '');
      } else {
        finalSelection = newValue ?? [];
      }

      setFieldValue('scorecardField', finalSelection);
      const scoreCardForSingle = finalSelection?.filter(v => v.scoreCard !== '');
      // console.log('scoreCardForSingle', scoreCardForSingle, Array.isArray(scoreCardForSingle) && scoreCardForSingle?.length > 0 ? scoreCardForSingle[0]?.scoreCard : '')
      setFieldValue("scoreCardSingle", Array.isArray(scoreCardForSingle) && scoreCardForSingle?.length > 0 ? scoreCardForSingle[0]?.scoreCard : '');
      // console.log('finalSelection', finalSelection, scoreCardForSingle, scoreCardForSingle[0]?.scoreCard)
      // Always send actual IDs — filter out the "All" placeholder (scoreCard === '')
      const scoreCardIds = finalSelection.filter(v => v.scoreCard !== '').map(v => v.scoreCard).join(',');
      setSelectedSupervisorScorecardFilter(scoreCardIds);

      const filterObj = {
        "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
        "toDate": moment(values.toDate).format('YYYY-MM-DD'),
        "filterBy": values.filterBy,
        "group": values.group,
        "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id).join(',') : '',
        "teams": values.teams,
        "scoreCard": scoreCardIds,
        "eventType": '',
        "eventTypeEventSubType": '',
        "supervisor": '',
        "staff": '',
        "scoreCardCategory": '',
        "evaluator": '',
      };
      getDataTagsByScoreCard(filterObj);
      // return;
    } else {

      // Single-select handling for other modules
      setFieldValue('scorecardField', newValue);
      setFieldValue("scoreCardSingle", newValue?.scoreCard ?? '');
      setFieldValue("scoreCard", [newValue?.scoreCard] ?? []);
      setSelectedSupervisorScorecardFilter(newValue?.scoreCard ?? '');
      const filterObj = {
        "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
        "toDate": moment(values.toDate).format('YYYY-MM-DD'),
        "filterBy": values.filterBy,
        "group": values.group,
        "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id).join(',') : '',
        "teams": values.teams,
        "scoreCard": (newValue?.scoreCard || selectedSupervisorScorecardFilter || values?.scoreCardSingle) ?? '',
        "eventType": '',
        "eventTypeEventSubType": '',
        "supervisor": '',
        "staff": '',
        "scoreCardCategory": '',
        "evaluator": '',
      };
      getDataTagsByScoreCard(filterObj);
    }
  };
  // console.log('values-----', formik.values)
  const handleDateRangeChange = (event) => {

    // Resetting remaining fields
    setFieldValue("group", '');
    setFieldValue("teams", '');
    setFieldValue("scoreCardSingle", '');
    setFieldValue("eventType", '');
    setFieldValue("eventTypeEventSubType", '');
    setFieldValue("staff", '');
    setFieldValue("scoreCardCategory", '');
    setFieldValue("supervisor", '');
    setFieldValue("highlightValue", '');
    setFieldValue("section", '');
    setFieldValue("evaluator", '');
    setFieldValue('dataTag', [])
    // redux state fields
    if (subModLabel === 2.4) {
      setFieldValue('groupField', { id: '', name: 'All' });
      setFieldValue('scorecardField', {
        scoreCard: '', scoreCardName: 'All'
      });
    } else {
      setFieldValue('groupField', {});
      setFieldValue('scorecardField', {});
    }
    setFieldValue('teamField', {
      id: '', name: 'All'
    });

    setFieldValue("eventField", {
      eventType: '',
      eventTypeEventType: "All",
      scoreCard: ''
    })
    setFieldValue('eventSubField', {
      eventSubType: '',
      subType: 'All',
      scorecard: ''
    })

    const dateRange = event.target.value;
    setFieldValue("dateRange", dateRange);
    // setScorecardType(event.target.value);
    // console.log("dateRange", event.target.value)
    // resetting empty the redux store group list
    // newDispatchFun(handleFilterData([]))

    setSelectedSupervisorGroupFilter('')
    setSelectedSupervisorScorecardFilter('')
    setSelectedSupervisorTeamFilter('')
    setSelectedSupervisorDateAnaRange('');
    setSelectedSupervisorFilterBy('');
    setSelectedSupervisorEventTypeFilter('');
    setSelectedSupervisorEventSubTypeFilter('')
    setselectedSupervisorDataTagFilter([])
    switch (dateRange) {

      case 'Today':
        setCustomFilters(false);
        setFieldValue("fromDate", moment().format('YYYY-MM-DD'));
        setFieldValue("toDate", moment().format('YYYY-MM-DD'));
        setSelectedSupervisorFromDate(moment().format('YYYY-MM-DD'))
        setSelectedSupervisorToDate(moment().format('YYYY-MM-DD'))
        setSelectedSupervisorDateAnaRange('Today');
        break;
      case 'Yesterday':
        setCustomFilters(false);
        setFieldValue("fromDate", moment().subtract(1, 'days').format('YYYY-MM-DD'));
        setFieldValue("toDate", moment().subtract(1, 'days').format('YYYY-MM-DD'));
        setSelectedSupervisorFromDate(moment().subtract(1, 'days').format('YYYY-MM-DD'))
        setSelectedSupervisorToDate(moment().subtract(1, 'days').format('YYYY-MM-DD'))
        setSelectedSupervisorDateAnaRange('Yesterday');
        break;
      case 'This Week':
        setCustomFilters(false);
        setFieldValue("fromDate", moment().startOf('week').format('YYYY-MM-DD'));
        setFieldValue("toDate", moment().endOf('week').format('YYYY-MM-DD'));
        setSelectedSupervisorFromDate(moment().startOf('week').format('YYYY-MM-DD'))
        setSelectedSupervisorToDate(moment().endOf('week').format('YYYY-MM-DD'))
        setSelectedSupervisorDateAnaRange('This Week');
        break;
      case 'Last Week':
        setCustomFilters(false);
        setFieldValue("fromDate", moment().subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD'));
        setFieldValue("toDate", moment().subtract(1, 'weeks').endOf('week').format('YYYY-MM-DD'));
        setSelectedSupervisorFromDate(moment().subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD'))
        setSelectedSupervisorToDate(moment().subtract(1, 'weeks').endOf('week').format('YYYY-MM-DD'))
        setSelectedSupervisorDateAnaRange('Last Week');
        break;
      case 'This Month':
        setCustomFilters(false);
        setFieldValue("fromDate", moment().startOf('month').format('YYYY-MM-DD'));
        setFieldValue("toDate", moment().endOf('month').format('YYYY-MM-DD'));
        setSelectedSupervisorFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        setSelectedSupervisorToDate(moment().endOf('month').format('YYYY-MM-DD'))
        setSelectedSupervisorDateAnaRange('This Month');
        break;
      case 'Last Month':
        setCustomFilters(false);
        setFieldValue("fromDate", moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'));
        setFieldValue("toDate", moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'));
        setSelectedSupervisorFromDate(moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'))
        setSelectedSupervisorToDate(moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'))
        setSelectedSupervisorDateAnaRange('Last Month');
        break;
      case 'This Quarter':
        setCustomFilters(false);
        setFieldValue("fromDate", moment().quarter(moment().quarter()).startOf('quarter').format('YYYY-MM-DD'));
        setFieldValue("toDate", moment().quarter(moment().quarter()).endOf('quarter').format('YYYY-MM-DD'));
        setSelectedSupervisorFromDate(moment().quarter(moment().quarter()).startOf('quarter').format('YYYY-MM-DD'))
        setSelectedSupervisorToDate(moment().quarter(moment().quarter()).endOf('quarter').format('YYYY-MM-DD'))
        setSelectedSupervisorDateAnaRange('This Quarter');
        break;
      case 'Last Quarter':
        setCustomFilters(false);
        setFieldValue("fromDate", moment().subtract(1, 'quarter').startOf('quarter').format('YYYY-MM-DD'));
        setFieldValue("toDate", moment().subtract(1, 'quarter').endOf('quarter').endOf('month').format('YYYY-MM-DD'));
        setSelectedSupervisorFromDate(moment().subtract(1, 'quarter').startOf('quarter').format('YYYY-MM-DD'))
        setSelectedSupervisorToDate(moment().subtract(1, 'quarter').endOf('quarter').endOf('month').format('YYYY-MM-DD'))
        setSelectedSupervisorDateAnaRange('Last Quarter');
        break;
      case 'This Year':
        setCustomFilters(false);
        setFieldValue("fromDate", moment().startOf('year').format('YYYY-MM-DD'));
        setFieldValue("toDate", moment().endOf('year').format('YYYY-MM-DD'));
        setSelectedSupervisorFromDate(moment().startOf('year').format('YYYY-MM-DD'))
        setSelectedSupervisorToDate(moment().endOf('year').format('YYYY-MM-DD'))
        setSelectedSupervisorDateAnaRange('This Year');
        break;
      case 'Last Year':
        setCustomFilters(false);
        setFieldValue("fromDate", moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DD'));
        setFieldValue("toDate", moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD'));
        setSelectedSupervisorFromDate(moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DD'))
        setSelectedSupervisorToDate(moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD'))
        setSelectedSupervisorDateAnaRange('Last Year');
        break;
      case 'Custom Date Range':
        setCustomFilters(true);
        formik.setFieldValue("fromDate", moment());
        formik.setFieldValue("toDate", moment());
        setFieldValue("toWeek", toWeekNo[toWeekNo?.length - 1]);
        setFieldValue("fromWeek", fromWeekNo[fromWeekNo?.length - 1]);
        setSelectedSupervisorFromWeek(fromWeekNo[fromWeekNo?.length - 1]);
        setSelectedSupervisorToWeek(toWeekNo[toWeekNo?.length - 1])
        setSelectedSupervisorDateAnaRange('Custom Date Range');
        break;
      default:
        setFieldValue("fromDate", moment().format('YYYY-MM-DD'));
        setFieldValue("toDate", moment().format('YYYY-MM-DD'));
        break;
    }

  };

  const handleFromDate = (newValue) => {
    setFieldValue("group", '');
    setFieldValue("teams", '');
    setFieldValue("scoreCardSingle", '');
    setFieldValue("eventType", '');
    setFieldValue("eventTypeEventSubType", '');
    setFieldValue("staff", '');
    setFieldValue("scoreCardCategory", '');
    setFieldValue("supervisor", '');
    setFieldValue("highlightValue", '');
    setFieldValue("section", '');
    setFieldValue("evaluator", '');
    setFieldValue('dataTag', [])
    // redux state fields
    if (subModLabel === 2.4) {
      setFieldValue('groupField', { id: '', name: 'All' });
      setFieldValue('scorecardField', {
        scoreCard: '', scoreCardName: 'All'
      });
    } else {
      setFieldValue('groupField', {});
      setFieldValue('scorecardField', {});
    }
    setFieldValue('teamField', {
      id: '', name: 'All'
    });
    setFieldValue("eventField", {
      eventType: '',
      eventTypeEventType: "All",
      scoreCard: ''
    })
    setFieldValue('eventSubField', {
      eventSubType: '',
      subType: 'All',
      scorecard: ''
    })

    if (moment(newValue).format('MM-DD') === '01-01') {
      formik.setFieldValue("fromWeek", 1)
      setSelectedSupervisorFromWeek(1)
    } else {
      formik.setFieldValue("fromWeek", moment(newValue).year(moment(newValue).format('YYYY')).isoWeek());
      setSelectedSupervisorFromWeek(moment(newValue).year(moment(newValue).format('YYYY')).isoWeek());
    }

    setFieldValue("fromDate", newValue);
    setSelectedSupervisorFromDate(newValue);

    if (moment(newValue, "YYYY-MM-DD").isAfter(formik.values.toDate)) {
      formik.setFieldValue("toDate", newValue)
      setSelectedSupervisorToDate(newValue);
      if (moment(newValue).format('MM-DD') === '01-01') {
        formik.setFieldValue("toWeek", 1)
        setSelectedSupervisorToWeek(1)

      } else {
        formik.setFieldValue("toWeek", moment(newValue).year(moment(newValue).format('YYYY')).isoWeek());
        setSelectedSupervisorToWeek(moment(newValue).year(moment(newValue).format('YYYY')).isoWeek())
      }

    }
  }

  const handleToDate = (newValue) => {
    setFieldValue("group", '')
    if (moment(newValue).format('MM-DD') === '01-01') {
      formik.setFieldValue("toWeek", 1)
      setSelectedSupervisorToWeek(1)
    } else {
      formik.setFieldValue("toWeek", moment(newValue).year(moment(newValue).format('YYYY')).isoWeek());
      setSelectedSupervisorToWeek(moment(newValue).year(moment(newValue).format('YYYY')).isoWeek())
    }
    setFieldValue("toDate", newValue);
    setSelectedSupervisorToDate(newValue);

    // Extract year from full date
    const fullDate = moment(newValue);
    const extractyear = fullDate.year();

    if (moment(newValue, "YYYY-MM-DD").isBefore(formik.values.fromDate) && /^\d{4}$/.test(extractyear)) {
      formik.setFieldValue("fromDate", newValue)
      setSelectedSupervisorFromDate(newValue);
      if (moment(newValue).format('MM-DD') === '01-01') {
        formik.setFieldValue("fromWeek", 1)
        setSelectedSupervisorFromWeek(1)

      } else {
        formik.setFieldValue("fromWeek", moment(newValue).year(moment(newValue).format('YYYY')).isoWeek());
        setSelectedSupervisorFromWeek(moment(newValue).year(moment(newValue).format('YYYY')).isoWeek())
      }

    }
  }
  const handleFilterByChange = (event) => {

    // setFieldValue("filterByRange", filterBy);
    // setScorecardType(event.target.value);
    setFieldValue("group", '');
    setFieldValue("teams", '');
    setFieldValue("scoreCardSingle", '');
    setFieldValue("eventType", '');
    setFieldValue("eventTypeEventSubType", '');
    setFieldValue("staff", '');
    setFieldValue("scoreCardCategory", '');
    setFieldValue("supervisor", '');
    setFieldValue("highlightValue", '');
    setFieldValue("section", '');
    setFieldValue("evaluator", '');
    setFieldValue('dataTag', [])

    setFieldValue('groupField', {});
    setFieldValue('scorecardField', {});
    setFieldValue("eventField", {
      eventType: '',
      eventTypeEventType: "All",
      scoreCard: ''
    })
    setFieldValue('eventSubField', {
      eventSubType: '',
      subType: 'All',
      scorecard: ''
    })

    switch (event.target.value) {

      case 'created_at':
        setFieldValue("filterBy", 'created_at');
        setSelectedSupervisorFilterBy(event.target.value);
        break;
      case 'event_date':
        setFieldValue("filterBy", 'event_date');
        setSelectedSupervisorFilterBy(event.target.value);
        break;
      case 'updated_at':
        setFieldValue("filterBy", 'updated_at');
        setSelectedSupervisorFilterBy(event.target.value);
        break;
      default:
        setFieldValue("filterBy", 'created_at');
        setSelectedSupervisorFilterBy(event.target.value);
        break;
    }

  };

  const handleOpenEventTypeField = () => {
    updateState('openEventTypeField', true)
    const evntTypeFilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": values.scoreCard?.length > 0 ? values.scoreCard : (values.scoreCardSingle),
      "eventType": '',
      "eventTypeEventSubType": '',
      "supervisor": '',
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": '',
      "highlightValue": '',
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id).join(',') : ''
    }
    getScoreLogEventType(evntTypeFilterObj);

  }

  const handleEventTypeChange = (event, newVal) => {

    setFieldValue("eventTypeEventSubType", '');
    setFieldValue("staff", '');
    setFieldValue("scoreCardCategory", '');
    setFieldValue("supervisor", '');
    setFieldValue("highlightValue", 0);
    setFieldValue("section", '');
    setFieldValue("evaluator", '');
    // const selectedItem = reportsScoreLogEventType.find(item => item.eventType === event.target.value);
    setFieldValue('eventField', newVal);
    setFieldValue('eventType', newVal?.eventType);
    setSelectedSupervisorEventTypeFilter(newVal?.eventType);

    setFieldValue('eventSubField', {
      eventSubType: '',
      subType: 'All',
      scorecard: ''
    })

    const filterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id).join(',') : '',
      "teams": values.teams,
      "scoreCard": values.scoreCard,
      "eventType": event.target.value,
      "eventTypeEventSubType": '',
      "supervisor": '',
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": '',
    }


    // getScoreLogEvaluator(filterObj);
    // getScoreLogEventSubType(filterObj);


  };

  const handleOpenEventSubTypeField = () => {
    updateState('openEventSubTypeField', true)
    const evntSubTypeFilterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": values.scoreCard?.length > 0 ? values.scoreCard : (values.scoreCardSingle),
      "eventType": values.eventType,
      "eventTypeEventSubType": '',
      "supervisor": '',
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": '',
      "highlightValue": '',
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id).join(',') : ''
    }
    getScoreLogEventSubType(evntSubTypeFilterObj);

  }
  const handleEventSubTypeChange = (event, newVal) => {
    // setFieldValue("eventTypeEventSubType", '');
    setFieldValue("staff", '');
    setFieldValue("scoreCardCategory", '');
    setFieldValue("supervisor", '');
    setFieldValue("highlightValue", 0);
    setFieldValue("section", '');
    setFieldValue("evaluator", '');

    const filterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id).join(',') : '',
      "teams": values.teams,
      "scoreCard": values.scoreCard,
      "eventType": values.eventType,
      "eventTypeEventSubType": newVal?.eventSubType,
      "supervisor": '',
      "staff": '',
      "scoreCardCategory": '',
      "evaluator": '',
    }

    setFieldValue('eventSubField', newVal)
    setFieldValue('eventTypeEventSubType', newVal?.eventSubType);
  };

  const handleOpenEvalField = () => {
    updateState('openEvalField', true)
    const filterObj =
    {
      "fromDate": moment(values.fromDate).format('YYYY-MM-DD'),
      "toDate": moment(values.toDate).format('YYYY-MM-DD'),
      "filterBy": values.filterBy,
      "group": values.group,
      "teams": values.teams,
      "scoreCard": subModLabel === 1.5 ? values.scoreCardSingle2 : values.scoreCard,
      "eventType": values.eventType,
      "eventTypeEventSubType": values.eventTypeEventSubType,
      "supervisor": values.supervisor,
      "staff": values.staff,
      "scoreCardCategory": '',
      "evaluator": '',
      "highlightValue": values.highlightValue,
      "sup_grp": (loggedUserData?.staff?.staffType === 20 || loggedUserData?.staff?.staffType === 30) ? loggedUserData?.groups?.map(obj => obj.id).join(',') : ''
    }
    getScoreLogEvaluator(filterObj)
  }

  const handleEvalChange = (event, newVal) => {
    setFieldValue("evaluator", newVal?.evaluator)

    setFieldValue("evaluatorField", newVal)
    // setSelectedSupervisorEvaluatorFilter(event.target.value);
  }

  const handleAdvancedFilters = (event) => {
    setAdvanceFilters((advanceFilters) => !advanceFilters);
  };


  const renderOptions = (props, option) => {
    return <li {...props} key={option?.scoreCard} style={{ color: option?.scoreCardIsArchive ? 'red' : '' }}>
      {loadingState?.scorecardLoading ? 'Loading...' : option?.scoreCardName}
    </li>

  }

  const renderTeamOptions = (props, option) => {
    return <li {...props} key={option?.id}>
      {!loadingState?.teamLoading ? option?.name : 'Loading...'}
    </li>
  }
  const renderEventOptions = (props, option) => {
    return <li {...props} key={option?.eventType}>
      {
        loadingState?.eventTypeLoading ? 'Loading...' : <>
          <Typography sx={{ fontSize: '14px', display: 'inline' }}>{option?.eventTypeEventType}</Typography>&nbsp;
          <Typography sx={{
            display: 'inline-block', fontStyle: 'italic',
            fontSize: '12px', fontWeight: 'bold'
          }}>
            {
              option?.scorecard ? `(${option?.scorecard})` : ''
            }
          </Typography>
        </>
      }

    </li >
  }


  const renderEventSubOptions = (props, option) => {
    return <li {...props} key={option?.eventSubType}>
      {
        loadingState?.eventSubTypeLoading ? 'Loading...' : <>
          <Typography sx={{ fontSize: '14px', display: 'inline' }}>{option?.subType}</Typography>&nbsp;
          <Typography sx={{
            display: 'inline-block', fontStyle: 'italic',
            fontSize: '12px', fontWeight: 'bold'
          }}>
            {
              option?.scorecard ? `(${option?.scorecard})` : ''
            }
          </Typography>
        </>
      }

    </li >
  }

  const renderEvalOptions = (props, option) => {
    return <li {...props} key={option?.id}>
      {!loadingState?.evaluatorLoading ? `${option?.evaluatorFirstName} ${option?.evaluatorLastName}` : 'Loading...'}
    </li>
  }
  // console.log('loadingState', loadingState, 'values', values, reportsScoreLogScorecards)
  // (Object.values(values?.scorecardField))?.find((option) => option?.scoreCard === values?.scoreCardSingle)
  // const t =
  // console.log('asu ----',Object.entries(values?.scorecardField), [values?.scorecardField]?.find((option) => option?.scoreCard === values?.scoreCardSingle))
  return (
    <div>

      {addUserButton &&
        <Button variant="contained" onClick={handleClickOpen} className="halloween-animation">
          Filter
        </Button>
      }

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <DialogTitle sx={{ pb: 2 }} > <h3>Report Filter</h3>
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 15,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <Close />
              </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent style={{ paddingTop: '20px' }}>
              <Stack spacing={3}>

                <Stack direction={{ xs: 'column', sm: 'row' }} sx={{ p: 0 }}>
                  <FormControl fullWidth sx={{ display: "flex", justifyContent: "end", alignItems: "end" }}>
                    {subModLabel !== 3.3 &&
                      <Button startIcon={advanceFilters ? <VisibilityOffIcon /> : <VisibilityIcon />}
                        sx={{ p: 0 }} onClick={handleAdvancedFilters}>
                        {advanceFilters ? 'Hide Advanced Filters' : 'Show Advanced Filters'}
                      </Button>}
                  </FormControl>
                </Stack>
                <Divider />


                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <FormControl fullWidth>
                    <InputLabel id="date-range-label">Date Range</InputLabel>
                    <Select
                      labelId="date-range-label"
                      id="demo-select-small"
                      value={values.dateRange}
                      label="Date Range"
                      name="dateRange"
                      {...getFieldProps('dateRange')}
                      onChange={(e) => { handleDateRangeChange(e) }}
                    >
                      {DateRangeList?.map((item) => (
                        <MenuItem key={item.id} id={item.id} value={item.dateRange}>
                          {item.dateRange}
                        </MenuItem >
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl fullWidth>
                    <InputLabel id="filter-by-label">Filter By</InputLabel>
                    <Select
                      labelId="filter-by-label"
                      id="demo-select-small"
                      value={values.filterBy}
                      label="Filter By"
                      name="filterBy"

                      {...getFieldProps('filterBy')}
                      onChange={handleFilterByChange}
                    >
                      {filterByList?.map((item) => (
                        <MenuItem key={item.id} id={item.id} value={item.id}>
                          {item.type}
                        </MenuItem >
                      ))}
                    </Select>
                  </FormControl>
                </Stack>
                {customFilters && <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                    <Box sx={{ width: "50%" }}>
                      <DesktopDatePicker
                        label="Date From"
                        inputFormat="yyyy/MM/dd"
                        name="fromDate"
                        minDate={new Date(dataCreatedFrom)}
                        disableFuture
                        {...getFieldProps('fromDate')}
                        onChange={(newValue) => {
                          handleFromDate(newValue)
                        }}
                        renderInput={(params) => <TextField fullWidth {...params} />}
                      />
                      {formik.errors.eventDate && formik.touched.eventDate && <Typography variant="caption" sx={{ color: "red", ml: 1 }}>{formik.errors.eventDate}</Typography>}
                    </Box>

                    <Box sx={{ width: "50%" }}>
                      <DesktopDatePicker
                        label="Date To"
                        inputFormat="yyyy/MM/dd"
                        name="toDate"
                        minDate={new Date(dataCreatedFrom)}
                        disableFuture
                        {...getFieldProps('toDate')}
                        onChange={(newValue) => {
                          handleToDate(newValue)
                        }}
                        renderInput={(params) => <TextField fullWidth {...params} />}
                      />
                      {formik.errors.eventDate && formik.touched.eventDate && <Typography variant="caption" sx={{ color: "red", ml: 1 }}>{formik.errors.eventDate}</Typography>}
                    </Box>
                  </Stack>
                </LocalizationProvider>}
                {customFilters && <Stack direction="row" sx={{ width: "100%", mb: 2 }} spacing={2}>
                  <Box sx={{ width: "50%" }}>
                    <TextField
                      fullWidth
                      required
                      value={formik.values.fromWeek}
                      multiple={false}
                      select
                      name="fromWeek"
                      onChange={(e) => {
                        moment.updateLocale('en', {
                          week: {
                            dow: 1
                          }
                        });
                        formik.setFieldValue("fromWeek", e.target.value);
                        setSelectedSupervisorFromWeek(e.target.value);
                        formik.setFieldValue("fromDate", moment().week(e.target.value).startOf('week'));
                        setSelectedSupervisorFromDate(moment().week(e.target.value).startOf('week'))
                      }}

                    >
                      {fromWeekNo?.map((item) => (
                        <MenuItem key={item} id={item} value={item}>
                          Week&nbsp;{item}
                        </MenuItem >
                      ))}

                    </TextField>
                  </Box>
                  <Box sx={{ width: "50%" }}>
                    <TextField
                      fullWidth
                      multiple={false}
                      value={formik.values.toWeek}
                      required
                      select
                      name="toWeek"
                      onChange={(e) => {
                        moment.updateLocale('en', {
                          week: {
                            dow: 1
                          }
                        });
                        formik.setFieldValue("toWeek", e.target.value);
                        setSelectedSupervisorToWeek(e.target.value);
                        formik.setFieldValue("toDate", moment().week(e.target.value).endOf('week'));
                        setSelectedSupervisorToDate(moment().week(e.target.value).endOf('week'));
                      }}

                    >
                      {toWeekNo?.map((item) => (
                        <MenuItem disabled={formik.values.fromWeek > item} key={item} id={item} value={item}>
                          Week&nbsp;{item}
                        </MenuItem >
                      ))}
                    </TextField>
                  </Box>

                </Stack>}

                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <FormControl fullWidth>
                    <Autocomplete
                      open={state?.openGroupField}
                      onOpen={handleOpenGroupFields}
                      onClose={handleCloseFields}
                      value={
                        (() => {
                          if (reportsScoreLogGroups) {
                            if (subModLabel === 2.4) {
                              return [{ name: 'All', id: '' }, ...reportsScoreLogGroups]
                                .find((option) => option?.id === values?.group) ?? null;
                            }
                            return reportsScoreLogGroups.find((option) => option?.id === values?.group) ?? null;
                          }

                          if (subModLabel !== 2.4) {
                            if (values.groupField?.name === 'All') {
                              return null; // Hide "All"
                            }
                            return values.groupField ?? null;
                          }

                          return values.groupField ?? null;
                        })()
                      }
                      options={
                        (() => {
                          if (reportsScoreLogGroups) {
                            if (subModLabel === 2.4) {
                              return [{ name: 'All', id: '' }, ...reportsScoreLogGroups];
                            }
                            return reportsScoreLogGroups;
                          }

                          if (subModLabel !== 2.4) {
                            if (values.groupField?.name === 'All') {
                              return []; // no "All"
                            }
                            return values.groupField ? [values.groupField] : [];
                          }

                          return values.groupField ? [values.groupField] : [];
                        })()
                      }
                      getOptionLabel={(option) => option?.name || ""}
                      isOptionEqualToValue={(option, value) => option?.id === value?.id}

                      renderOption={(props, option) => {
                        return <li {...props} key={option?.id}>
                          {!loadingState?.groupLoading ? option?.name : 'Loading...'}
                        </li>
                      }}
                      onChange={(event, newValue) => {
                        handleGroupChange(event, newValue);
                      }}

                      id="controllable-states-demo"
                      renderInput={(params) => <TextField {...params}
                        label="Group"
                        popoverprops={{
                          style: {
                            bottom: 0,
                            overflowY: 'auto'
                          }
                        }}
                        variant="outlined"
                        // error={Boolean(touched.group && errors.group)}
                        // helperText={touched.group && errors.group}
                        error={subModLabel === 2.4 ? false : values?.group === ''}
                        helperText={values?.group === '' ? errors.group : null}
                        required
                      />
                      }
                    />
                  </FormControl>
                  {(subModLabel === 2.4) && <FormControl fullWidth>
                    <Autocomplete
                      fullWidth
                      open={state?.openTeamField}
                      onOpen={handleOpenTeamFields}
                      onClose={handleCloseFields}
                      value={
                        reportsScoreLogTeams ?
                          ([{
                            name: 'All', id: ''
                          }].concat(reportsScoreLogTeams))?.find((option) => option?.id === values?.teams)
                          :
                          values?.teamField ?? null
                      }
                      options={
                        (() => {
                          if (reportsScoreLogTeams) return [{ name: 'All', id: '' }, ...reportsScoreLogTeams];

                          // If API not loaded
                          if (values?.teamField) return [values.teamField];

                          return [{}];
                        })()
                      }
                      getOptionLabel={(option) => option?.name || ""}
                      renderOption={renderTeamOptions}
                      isOptionEqualToValue={(option, value) => option?.id === value?.id}
                      onChange={(e, newVal) => handleTeamChange(e, newVal)}
                      renderInput={(params) =>
                        <TextField {...params} label="Teams"
                          popoverProps={{
                            style: {
                              bottom: 0,
                              overflowY: 'auto'
                            }
                          }}
                          variant="outlined"

                        />}

                    />
                  </FormControl>
                  }
                </Stack>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <FormControl fullWidth>
                    {subModLabel === 2.1 ? (
                      // Multi-select Autocomplete for module 2.1 with "All" option
                      <Autocomplete
                        multiple
                        open={state?.openScorecardField}
                        onOpen={handleOpenScorecardFields}
                        onClose={handleCloseFields}
                        value={Array.isArray(values.scorecardField) ? values.scorecardField : []}
                        options={(() => {
                          if (reportsScoreLogScorecards) {
                            return [{ scoreCardName: 'All', scoreCard: '' }, ...reportsScoreLogScorecards];
                          }
                          if (Array.isArray(values.scorecardField) && values.scorecardField.length > 0) {
                            return values.scorecardField;
                          }
                          return [];
                        })()}
                        getOptionLabel={(option) => option?.scoreCardName || ""}
                        renderOption={(props, option) => (
                          <li {...props} key={option?.scoreCard ?? 'all'} style={{ color: option?.scoreCardIsArchive ? 'red' : '' }}>
                            {loadingState?.scorecardLoading ? 'Loading...' : option?.scoreCardName}
                          </li>
                        )}
                        renderTags={(tagValue, getTagProps) =>
                          tagValue.map((option, index) => (
                            <Chip
                              variant="outlined"
                              label={option?.scoreCardName}
                              {...getTagProps({ index })}
                              key={option?.scoreCard ?? 'all'}
                            />
                          ))
                        }
                        onChange={(event, newValue) => handleScorecardChange(event, newValue)}
                        isOptionEqualToValue={(option, value) => option?.scoreCard === value?.scoreCard}
                        disableCloseOnSelect
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Scorecard"
                            variant="outlined"
                            error={Boolean(touched.scorecardField && errors.scorecardField)}
                            helperText={touched.scorecardField && errors.scorecardField}
                            required
                          />
                        )}
                      />
                    ) : (
                      // Single-select Autocomplete for all other modules
                      <Autocomplete
                        open={state?.openScorecardField}
                        onOpen={handleOpenScorecardFields}
                        onClose={handleCloseFields}
                        value={
                          (() => {
                            if (reportsScoreLogScorecards) {
                              if (subModLabel === 2.4) {
                                return [{ scoreCardName: 'All', scoreCard: '' }, ...reportsScoreLogScorecards]
                                  .find((option) => option?.scoreCard === values?.scoreCardSingle) ?? null;
                              }
                              return reportsScoreLogScorecards.find((option) => option?.scoreCard === values?.scoreCardSingle) ?? null;
                            }
                            let targetField = null;

                            if (Array.isArray(values.scorecardField)) {
                              // remove invalid entries
                              const validItems = values.scorecardField.filter(
                                v => v?.scoreCard !== '' && v?.scoreCardName !== 'All'
                              );

                              // take first valid object
                              targetField = validItems[0] || null;

                            } else if (values.scorecardField) {
                              targetField = values.scorecardField;
                            }

                            // Check the "All" condition
                            if (subModLabel !== 2.4) {
                              if (targetField?.scoreCardName === 'All') {
                                return null;
                              }
                            }
                            return targetField ?? null;
                            // if (subModLabel !== 2.4) {
                            //   if (values.scorecardField?.scoreCardName === 'All') {
                            //     return null;
                            //   }
                            //   return values.scorecardField ?? null;
                            // }

                            // return values.scorecardField ?? null;
                          })()
                        }
                        options={
                          (() => {
                            if (reportsScoreLogScorecards) {
                              if (subModLabel === 2.4) {
                                return [{ scoreCardName: 'All', scoreCard: '' }, ...reportsScoreLogScorecards];
                              }
                              return reportsScoreLogScorecards;
                            }

                            // 1. Initialize an empty array
                            let scorecardArray = [];

                            // 2. Handle the normalization without nesting ternaries
                            if (Array.isArray(values.scorecardField)) {
                              scorecardArray = values.scorecardField;
                            } else if (values.scorecardField) {
                              // If it's a single object, wrap it in an array
                              scorecardArray = [values.scorecardField];
                            }

                            // 3. Check for the "All" condition
                            const firstItem = scorecardArray[0];

                            if (subModLabel !== 2.4 && firstItem?.scoreCardName === 'All') {
                              return [];
                            }

                            // 4. Return the clean array
                            return scorecardArray;
                            // if (subModLabel !== 2.4) {
                            //   if (values.scorecardField?.scoreCardName === 'All') {
                            //     return [];
                            //   }
                            //   return values.scorecardField ? [values.scorecardField] : [];
                            // }

                            // return values.scorecardField ? [values.scorecardField] : [];
                          })()
                        }
                        getOptionLabel={(option) => option?.scoreCardName || ""}
                        renderOption={renderOptions}
                        onChange={(event, newValue) => {
                          handleScorecardChange(event, newValue);
                        }}
                        id="controllable-states-demo"
                        isOptionEqualToValue={(option, value) => {
                          let equalOptions;
                          if (option?.scoreCard) {
                            equalOptions = option?.scoreCard === value?.scoreCard;
                          } else {
                            equalOptions = filterFieldsData?.scorecardField?.scoreCard === value?.scoreCard;
                          }
                          return equalOptions;
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Scorecard"
                            popoverprops={{
                              style: {
                                bottom: 0,
                                overflowY: 'auto'
                              }
                            }}
                            variant="outlined"
                            error={Boolean(touched.scoreCardSingle && errors.scoreCardSingle)}
                            helperText={touched.scoreCardSingle && errors.scoreCardSingle}
                            required
                          />
                        )}
                      />
                    )}
                  </FormControl>
                  {
                    (dataTagByScoreCard?.data?.length > 0) && <> <FormControl fullWidth>
                      <InputLabel shrink id="demo-multiple-name-label">Data Tag(s)</InputLabel>
                      <Select
                        name='dataTag'
                        labelId="demo-multiple-name-label"
                        id="demo-multiple-name"
                        multiple
                        value={values.dataTag}
                        {...getFieldProps('dataTag')}
                        input={<OutlinedInput notched label="Data Tag(s)" />}
                        onChange={handleDataTags}
                      >
                        {dataTagByScoreCard?.data?.map((item, i) => (
                          <MenuItem key={i} id={item.dataTags} value={item.dataTags}>
                            {item.dataTagsName}
                          </MenuItem >
                        ))}
                      </Select>
                    </FormControl>
                    </>
                  }

                </Stack>
                {dataTagByScoreCard?.data?.length > 0 && <Stack direction={{ sm: 'row' }} spacing={0} alignItems="flex-end" justifyContent="flex-end">
                  <FormControlLabel
                    name="anyOfTag"
                    sx={{ marginLeft: '0px', marginRight: '0px' }}
                    // value="10"
                    control={<Radio />}
                    label="Any of the Tags"
                    checked={isAnyOfTag}
                    onChange={handleAnyOfTag}
                  />
                  {/* {...getFieldProps('anyOfTag')} */}

                  <FormControlLabel
                    name="allOfTag"
                    sx={{ marginLeft: '0px', marginRight: '0px' }}
                    // value="20"
                    control={<Radio />}
                    label="All of the Tags"
                    onChange={handleAllOfTag}
                    checked={isAllOfTag}


                  />
                  {/* {...getFieldProps('allOfTag')} */}

                </Stack>

                }
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <FormControl fullWidth>
                    {/* <InputLabel shrink id="group-label">Event Type</InputLabel> */}
                    <Autocomplete
                      open={state?.openEventTypeField}
                      onClose={handleCloseFields}
                      onOpen={handleOpenEventTypeField}
                      value={
                        reportsScoreLogEventType ? ([{
                          eventType: '',
                          eventTypeEventType: 'All',
                          scorecard: ''
                        }].concat(reportsScoreLogEventType))?.find((options) => options?.eventType === values?.eventType)
                          : values?.eventField
                      }
                      options={([{
                        eventType: '',
                        eventTypeEventType: 'All',
                        scorecard: ''
                      }].concat(reportsScoreLogEventType))}
                      // getOptionLabel={(option) => `${option?.eventTypeEventType}&nbsp;${option?.scorecard}` || ""}
                      getOptionLabel={(option) =>
                        option?.eventTypeEventType
                          ? `${option.eventTypeEventType} ${option.scorecard ? `(${option.scorecard})` : ''}`
                          : ''
                      }
                      renderOption={renderEventOptions}

                      onChange={(e, newVal) => handleEventTypeChange(e, newVal)}
                      isOptionEqualToValue={(option, value) => option?.eventType === value?.eventType}

                      renderInput={(params) => <TextField {...params} label="Event Type"
                        popoverprops={{
                          style: {
                            bottom: 0,
                            overflowY: 'auto'
                          }
                        }}
                        variant="outlined"
                      />}
                    // {...getFieldProps('eventType')}
                    // MenuProps={{
                    //   PaperProps: {
                    //     sx: {
                    //       maxHeight: 150,
                    //       mt: 1,
                    //       bgcolor: 'white',
                    //       color: 'black'
                    //     }
                    //   },
                    //   anchorOrigin: {
                    //     vertical: 'bottom',
                    //     horizontal: 'left',
                    //   },
                    //   transformOrigin: {
                    //     vertical: 'top',
                    //     horizontal: 'left',
                    //   },
                    //   disablePortal: true // <== IMPORTANT: ensures dropdown appears right under the Select
                    // }}

                    />

                  </FormControl>

                  <FormControl fullWidth>
                    {/* <InputLabel shrink id="teams-label">Event Sub Type</InputLabel> */}
                    <Autocomplete
                      open={state?.openEventSubTypeField}
                      onClose={handleCloseFields}
                      onOpen={handleOpenEventSubTypeField}
                      value={
                        reportsScoreLogEventSubType ? ([{
                          eventSubType: '',
                          subType: 'All',
                          scorecard: ''
                        }].concat(reportsScoreLogEventSubType))?.find((options) => options?.eventSubType === values?.eventTypeEventSubType)
                          : values?.eventSubField
                      }
                      options={([{
                        eventSubType: '',
                        subType: 'All',
                        scorecard: ''
                      }].concat(reportsScoreLogEventSubType))}
                      getOptionLabel={(option) =>
                        option?.subType || option?.scorecard
                          ? `${option.subType} ${option.scorecard ? `(${option.scorecard})` : ''}`
                          : ''
                      }
                      renderOption={renderEventSubOptions}

                      onChange={(e, newVal) => handleEventSubTypeChange(e, newVal)}
                      isOptionEqualToValue={(option, value) => option?.eventSubType === value?.eventSubType}

                      renderInput={(params) => <TextField {...params} label="Event Sub Type"
                        popoverprops={{
                          style: {
                            bottom: 0,
                            overflowY: 'auto'
                          }
                        }}
                        variant="outlined"
                      />
                      }
                    />
                  </FormControl>

                </Stack>
                {
                  advanceFilters &&
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                    {
                      subModLabel !== 2.4 && <FormControl sx={{ width: "50%" }}>
                        <TextField
                          fullWidth
                          label="Highlight Below"
                          value={formik.values.highlightValue}
                          {...getFieldProps('highlightValue')}
                          onClick={(e) => {
                            formik.setFieldValue("highlightValue", e.target.value);
                          }}
                          error={Boolean(touched.highlightValue && errors.highlightValue)}
                          helperText={touched.highlightValue && errors.highlightValue}
                        />
                      </FormControl>
                    }

                    {(subModLabel === 2.1 || subModLabel === 2.3) &&
                      <FormControl sx={{ width: "50%" }}>
                        <InputLabel shrink id="group-label">
                          Formula
                        </InputLabel>
                        <Select
                          labelId="group-label"
                          id="demo-select-small"
                          displayEmpty
                          value={formik?.values.formula}
                          input={<OutlinedInput notched label="Formula" />}
                          {...getFieldProps('formula')}
                        >
                          {/* <MenuItem value=""> Select </MenuItem > */}

                          {formulaType?.map((item) => (
                            <MenuItem key={item.id} id={item.id} value={item.id}>
                              {item.type}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    }
                  </Stack>

                }
                {(advanceFilters && subModLabel === 2.4) && <FormControl sx={{ width: "50%" }}>
                  <Autocomplete
                    open={state?.openEvalField}
                    onClose={handleCloseFields}
                    onOpen={handleOpenEvalField}
                    value={
                      reportsScoreLogEvaluator ? ([{
                        evaluator: '',
                        evaluatorFirstName: 'All',
                        evaluatorLastName: ''
                      }].concat(reportsScoreLogEvaluator))?.find((options) => options?.evaluator === values?.evaluator)
                        : values?.evaluatorField ?? null
                    }
                    options={reportsScoreLogEvaluator ? ([{
                      evaluator: '',
                      evaluatorFirstName: 'All',
                      evaluatorLastName: ''
                    }].concat(reportsScoreLogEvaluator)) : [values?.evaluatorField]}
                    getOptionLabel={(option) =>
                      (option?.evaluatorFirstName || option.evaluatorLastName)
                        ? `${option.evaluatorFirstName} ${option.evaluatorLastName}`
                        : ''
                    }
                    renderOption={renderEvalOptions}

                    onChange={(e, newVal) => handleEvalChange(e, newVal)}
                    isOptionEqualToValue={(option, value) => {

                      let equalOptions
                      if (option?.evaluator) {
                        equalOptions = option?.evaluator === value?.evaluator
                      } else {
                        equalOptions = filterFieldsData?.evaluatorField?.evaluator === value?.evaluator
                      }
                      return equalOptions
                    }}
                    renderInput={(params) => <TextField {...params} label="Evaluators"
                      popoverprops={{
                        style: {
                          bottom: 0,
                          overflowY: 'auto'
                        }
                      }}
                      variant="outlined"
                    />
                    }

                  />
                </FormControl>
                }
              </Stack>
            </DialogContent>

            <DialogActions>
              <Button onClick={() => { handleClose() }} color="inherit">
                Cancel
              </Button>
              <Button type="submit" disabled={circular} variant="contained" loading={isSubmitting?.toString()}>
                Apply{circular && <CircularProgress size={14} sx={{ ml: 1 }} />}
              </Button>
            </DialogActions>
          </Form>
        </FormikProvider>
      </Dialog>
    </div>
  );
}